import { kakaoChannelUrlSchema, type UpdateSiteSettingsInput } from '@repo/api-contracts';

export type KakaoChannelFormResult =
  | { readonly ok: true; readonly input: UpdateSiteSettingsInput }
  | { readonly ok: false; readonly error: string };

/**
 * 카카오톡 채널 주소 칸 해석 — 비우면 주소 없음(null, 버튼이 사라진다), 아니면 계약 `kakaoChannelUrlSchema`(서버와 같은 기준)로
 * 공백을 지우고 형식을 검사한다.
 */
export const parseKakaoChannelForm = (value: string): KakaoChannelFormResult => {
  if (value.trim() === '') return { ok: true, input: { kakaoChannelUrl: null } };
  const parsed = kakaoChannelUrlSchema.safeParse(value);
  return parsed.success
    ? { ok: true, input: { kakaoChannelUrl: parsed.data } }
    : { ok: false, error: parsed.error.issues[0]?.message ?? '주소 형식이 맞지 않습니다.' };
};
